/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SellPriceProductService = {

  async getPriceGroupRRPProductList() {
    const requestScreenData = {
      url: "api/PriceGroupRRPProductList",
      // expand: "PriceGroupRRPProductGroups",
      expand: "PriceGroupRRPProductGroups($orderby=PriceGroupID asc)",
      orderby: "ProductDescription1 asc",
      // filter: "ProductCode eq 'SM-B1401' or ProductCode eq 'CON10PETPOUCH'", //ProductTypeCode asc
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async getPriceGroupRRPProductGroupList() {
    const requestScreenData = {
      url: "api/PriceGroupRRPProductGroupList",
      count: true
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },


  async saveSellPriceProduct(payload, id) {
    const url = `api/Save_PriceGroupRRP`;

    if (id) {
      return await ApiService.put(url, id, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },
};

export { SellPriceProductService };
